import QuickNav from "../../HomePage/HeroSection/QuickNav";
import WepAppBanner from "../../HomePage/Services/WepAppBanner";
import SampleProjects from "./SampleProjects/SampleProjects";
import ServicesWebFQA from "../../HomePage/Services/ServicesWebFQA";
import { FeaturesSection } from "../WebDevelopment/FeaturesSection/FeaturesSection";
import FooterContact from "../../FooterContactPage/FooterContact";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const WebDev = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const QuickNavItems = ["Samples", "Features", "FAQ", "Form"];
  return (
    <div>
      <>
      <Helmet>
        <title>Web Development Company in Bangladesh | Quad Theory Ltd</title>
        <meta
          name="description"
          content="Quad Theory Ltd is a web development company in Bangladesh building fast, scalable websites and web applications. Custom development focused on performance, long term maintainability, and real business use."
        />
      </Helmet>
      </>
      <WepAppBanner />
      <QuickNav items={QuickNavItems} />
      <SampleProjects />
      <FeaturesSection />
      <ServicesWebFQA />
      <FooterContact />
    </div>
  );
};

export default WebDev;
